import { ClipboardList, Database, MessageSquare, Send, ShoppingCart } from "lucide-react";
import { useState } from "react";
import { OperationConfirmDialog } from "../../../../../components/ui/operation-confirm-dialog";
import { Button } from "../../../../../components/ui/button";
import { EnviarOfertasDialog } from "./enviar-ofertas-dialog";

interface CheckoutActionButtonsProps {
  status: string;
  ops: string;
  date: string;
  onConfirmCheckout: () => void;
  // TEMP-SPLIT-OFERTA: presentes só na página do entrego. Sem onEnviarOfertas o
  // componente mantém o layout antigo (botão WhatsApp, sem Enviar Ofertas) para o
  // consumidor genérico (checkout-operation-card, demais ops).
  // PILOTO ENCERRADO (2026-10-02): a página do entrego também não passa mais
  // onEnviarOfertas, então hoje TODOS os consumidores caem no layout WhatsApp.
  onEnviarOfertas?: () => void;
  isEnviandoOfertas?: boolean;
  onStartDoc: () => void;
  onSubmitRemessa: () => void;
  isConfirming: boolean;
  isStartingDoc: boolean;
  isSubmittingRemessa: boolean;
}

export function CheckoutActionButtons({
  status,
  ops,
  date,
  onConfirmCheckout,
  onEnviarOfertas,
  onStartDoc,
  onSubmitRemessa,
  isConfirming,
  isEnviandoOfertas = false,
  isStartingDoc,
  isSubmittingRemessa,
}: CheckoutActionButtonsProps) {
  const [openRegistro, setOpenRegistro] = useState(false);
  const [openEnviarOfertas, setOpenEnviarOfertas] = useState(false);
  const [openCompra, setOpenCompra] = useState(false);
  const [openInsertDb, setOpenInsertDb] = useState(false);

  // TEMP-SPLIT-OFERTA: split registro/envio habilitado só quando a página passa
  // onEnviarOfertas (entrego).
  // PILOTO ENCERRADO: hoje sempre false — os ramos hasSplitOfertas abaixo
  // ("Registro de Ofertas", botão e diálogo de envio) são código do piloto inativo.
  const hasSplitOfertas = !!onEnviarOfertas;
  const isRegistroDisabled = status === "closed" || status === "committed";
  // TEMP-SPLIT-OFERTA: envio ativo só depois do registro (status confirmed);
  // reenviável — o backend filtra quem já aceitou a oferta.
  const isEnviarOfertasDisabled = status !== "confirmed";
  const isDocDisabled = status === "requested" || status === "committed";
  // Ciclo: requested → confirmed → closed → payment_requested → committed.
  // "Inserir DB" é justamente quem grava o committed (gestorSubmitRemessaDb),
  // então ele precisa ficar ativo nos dois estados do meio — closed e
  // payment_requested. Listar "closed" aqui cobria todo o ciclo anterior ao
  // commit e o botão nunca habilitava, travando o fluxo. A lista é de status
  // BLOQUEADOS de propósito: o que não está nela habilita. Mesma correção que
  // 6149cbc fez no card do indrive, que não passa por este componente.
  const isInsertDbDisabled =
    status === "requested" || status === "confirmed" || status === "committed";

  return (
    <div className="flex gap-2">
      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpenRegistro(true)}
        disabled={isRegistroDisabled || isConfirming}
      >
        {hasSplitOfertas ? (
          <ClipboardList className="h-4 w-4 mr-2" />
        ) : (
          <MessageSquare className="h-4 w-4 mr-2" />
        )}
        {hasSplitOfertas ? "Registro de Ofertas" : "WhatsApp"}
      </Button>

      {hasSplitOfertas && (
        <Button
          size="sm"
          variant="outline"
          onClick={() => setOpenEnviarOfertas(true)}
          disabled={isEnviarOfertasDisabled || isEnviandoOfertas}
        >
          <Send className="h-4 w-4 mr-2" />
          Enviar Ofertas
        </Button>
      )}

      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpenCompra(true)}
        disabled={isDocDisabled || isStartingDoc}
      >
        <ShoppingCart className="h-4 w-4 mr-2" />
        Compra
      </Button>

      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpenInsertDb(true)}
        disabled={isInsertDbDisabled || isSubmittingRemessa}
      >
        <Database className="h-4 w-4 mr-2" />
        Inserir DB
      </Button>

      <OperationConfirmDialog
        open={openRegistro}
        onOpenChange={setOpenRegistro}
        onConfirm={onConfirmCheckout}
        action={hasSplitOfertas ? "registro-ofertas" : "whatsapp"}
        ops={ops}
        date={date}
        loading={isConfirming}
      />

      {hasSplitOfertas && (
        <EnviarOfertasDialog
          open={openEnviarOfertas}
          onOpenChange={setOpenEnviarOfertas}
          onConfirm={onEnviarOfertas!}
          ops={ops}
          date={date}
          loading={isEnviandoOfertas}
        />
      )}

      <OperationConfirmDialog
        open={openCompra}
        onOpenChange={setOpenCompra}
        onConfirm={onStartDoc}
        action="compra"
        ops={ops}
        date={date}
        loading={isStartingDoc}
      />

      <OperationConfirmDialog
        open={openInsertDb}
        onOpenChange={setOpenInsertDb}
        onConfirm={onSubmitRemessa}
        action="inserir-db"
        ops={ops}
        date={date}
        loading={isSubmittingRemessa}
      />
    </div>
  );
}
